import axios from "axios";

const URL = `${process.env.REACT_APP_API_URL}`;

export const requestLoginUser = (body) => axios.post(`${URL}login-by-code`, body);

/* export const requestLoginUser = (body) => axios.post(`${URL}login`, body);*/
export const requestMe = () => axios.post(`${URL}me`);
export const requestLogout = () => axios.post(`${URL}logout`)
export const requestUpdateProfile = (body) => axios.post(`${URL}profile`, body)
export const requestCode = (body) => axios.post(`${URL}get-code`, body)
export const requestAccceptAgreement = () => axios.post(`${URL}agreement`)